import {
    Button,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import React, { useState } from 'react';
import { useParams } from 'react-router';
import FormSection from '../../../../components/atom/FormSection';
import ActionIconButton from '../../../../components/atom/ActionIconButton';
import { useNotify } from '../../../../hooks/useNotify';
import { doSwaggerCall, useSwaggerClient } from '../../../../hooks/useSwaggerClient';
import { CheckIcon, DeleteIcon, EditIcon, PlusIcon, TimesIcon } from '../../../../icons';
import ReaderCreateOrEditForm from '../../readeredit/components/ReaderCreateOrEditForm';

const ReadersList = () => {
    const { locationId } = useParams();
    const { notifyError, notifySuccess } = useNotify();
    const [refreshReaders, setRefreshReaders] = useState(false);
    const [isAddingNewReader, setIsAddingNewReader] = useState(false);
    const [stripeError, setStripeError] = useState(false);
    const [readers, readersLoading, readersError] = useSwaggerClient(
        'terminals',
        'getReaders',
        {
            locationId
        },
        [refreshReaders]
    );

    const createReader = (values, { setSubmitting }) => {
        doSwaggerCall('terminals', 'createReader', {
            readerData: {
                location: locationId,
                label: values.label,
                registration_code: values.registration_code
            }
        })
            .then(() => {
                notifySuccess('Successfully created location');
                setStripeError(false);
            })
            .catch(err => {
                setStripeError(`${err.code} - ${err.message}`);
                notifyError(`${err.code} - ${err.message}`);
            })
            .finally(() => {
                setSubmitting(false);
                setIsAddingNewReader(false);
                setRefreshReaders(!refreshReaders);
            });
    };

    const deleteReader = id => {
        doSwaggerCall('terminals', 'deleteReader', {
            readerId: id
        })
            .then(() => {
                notifySuccess('Successfully deleted location');
                setStripeError(false);
            })
            .catch(err => {
                setStripeError(`${err.code} - ${err.message}`);
            })
            .finally(() => {
                setRefreshReaders(!refreshReaders);
            });
    };

    if (readersError) {
        <Grid container item xs={12} spacing={2} justifyContent="center">
            <Alert>Could not load terminals</Alert>
        </Grid>;
    }

    if (readersLoading) {
        return null;
    }

    return (
        <FormSection title="Terminals">
            <Grid item xs={12} spacing={2}>
                {isAddingNewReader ? (
                    <ReaderCreateOrEditForm
                        isCreate
                        stripeError={stripeError}
                        onBack={() => setIsAddingNewReader(false)}
                        onSubmit={createReader}
                    />
                ) : (
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Id</TableCell>
                                    <TableCell>Device type</TableCell>
                                    <TableCell>IP Address</TableCell>
                                    <TableCell>Label</TableCell>
                                    <TableCell>Live mode</TableCell>
                                    <TableCell>Serial number</TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell style={{ width: '100px' }}>Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {readers?.map(reader => (
                                    <TableRow key={reader.id}>
                                        <TableCell>{reader.id}</TableCell>
                                        <TableCell>{reader.device_type}</TableCell>
                                        <TableCell>{reader.ip_address}</TableCell>
                                        <TableCell>{reader.label}</TableCell>
                                        <TableCell>
                                            {reader.livemode ? (
                                                <Tooltip title="In live mode">
                                                    <CheckIcon color="success" />
                                                </Tooltip>
                                            ) : (
                                                <Tooltip title="In test mode">
                                                    <TimesIcon color="error" />
                                                </Tooltip>
                                            )}
                                        </TableCell>
                                        <TableCell>{reader.serial_number}</TableCell>
                                        <TableCell>{reader.status}</TableCell>
                                        <TableCell>
                                            <ActionIconButton
                                                title="Edit"
                                                icon={EditIcon}
                                                to={`/admin/terminalreaders/${reader.id}`}
                                            />
                                            <ActionIconButton
                                                title="Delete"
                                                icon={DeleteIcon}
                                                onClick={() => deleteReader(reader.id)}
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))}
                                <TableRow>
                                    <TableCell colSpan={8} align="right">
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            startIcon={<PlusIcon />}
                                            onClick={() => setIsAddingNewReader(true)}
                                        >
                                            New terminal
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Grid>
        </FormSection>
    );
};

export default ReadersList;
